/**
 * پیش‌نویسِ «ارسال به کارشناس فنی» — تا ادیتور با بستن پنجره، عوض کردن تب یا
 * حتی رفرش مرورگر تصویرهای چسبانده‌شده را از دست ندهد.
 *
 * تصویرها (File) در IndexedDB نگه داشته می‌شوند چون localStorage فقط متن
 * می‌گیرد و اسکرین‌شات چند مگابایت است. اگر IndexedDB در دسترس نبود (مثلاً
 * پنجره‌ی خصوصی)، حافظه‌ی همین صفحه جایگزین است: با رفرش از بین می‌رود ولی
 * با بستن پنجره یا عوض کردن تب می‌ماند. هیچ خطایی به کاربر نشان داده نمی‌شود —
 * پیش‌نویس یک راحتی است، نه بخشی از ارسال.
 */

const DB_NAME = 'flowtrack-drafts';
const STORE = 'screen-check';

const memory = new Map();

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function withStore(mode, action) {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE, mode);
      const result = action(transaction.objectStore(STORE));
      transaction.oncomplete = () => resolve(result?.result);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    db.close();
  }
}

export async function loadDraft(caseId) {
  try {
    const stored = await withStore('readonly', (store) => store.get(caseId));
    if (stored) return stored;
  } catch (error) {
    // به حافظه‌ی صفحه برمی‌گردیم.
  }
  return memory.get(caseId) || null;
}

export async function saveDraft(caseId, draft) {
  const empty = !draft.photo1 && !draft.photo2 && !draft.text;
  if (empty) {
    await clearDraft(caseId);
    return;
  }
  memory.set(caseId, draft);
  try {
    await withStore('readwrite', (store) => store.put(draft, caseId));
  } catch (error) {
    // فقط حافظه‌ی صفحه.
  }
}

export async function clearDraft(caseId) {
  memory.delete(caseId);
  try {
    await withStore('readwrite', (store) => store.delete(caseId));
  } catch (error) {
    // چیزی برای پاک کردن نبود یا IndexedDB در دسترس نیست.
  }
}
